<template>
    <ul class="week-list" v-if="!loading">
        <li>Weekly Scores</li>
        <li v-for="week in weeks" v-bind:key="week.week">
            <router-link v-if="week.week !== 0" :to="{ name: 'weekScoreCard', params: getWeekRouteParams(week.week)}">{{week.week}}</router-link>
            <router-link v-else :to="{ name: 'weekScoreCard', params: getWeekRouteParams('bye')}">Bye</router-link>
        </li>
    </ul>
</template>

<script>
  export default {
    name: 'WeekList',
    props: ['season'],
    data() {
      return {
        error: null,
        loading: false,
        weeks: null
      }
    },
    methods: {
      async fetchData () {
        this.error = this.weeks = null;
        this.loading = true;

        try {
          const raw = await this.$apiClient.weeks(this.season.season_id);
          this.weeks = raw.data;
        } catch (e) {
          this.error = e;
        }

        this.loading = false;
      },
      getWeekRouteParams(weekId) {
        if (!this.season) {
          return {};
        }
        return {season: this.season.season_id, season_name: this.season.name.replace(' ', '-'), week: weekId}
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    created() {
      this.fetchData();
    }
  }
</script>

<style scoped>
    .week-list {
        padding: 0;
    }

    .week-list li {
        display: inline-block;
        padding: 10px 10px 0 10px;
        font-size: 15px;
    }

    .week-list li:first-child {
        padding-left: 0;
        font-size: inherit;
    }
</style>
